module.exports = __webpack_public_path__ + "images/services/github.8cab38550d1f23032fac.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/services/github.png
// module id = NOLp
// module chunks = 13